var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWallet(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36621 2.53604C6.96295 1.91815 7.92129 1.8229 8.62793 2.31045L12.4277 4.9335C12.4772 4.9677 12.5201 5.00783 12.5586 5.05069H16.1172C17.1567 5.05069 17.9999 5.89014 18 6.92569V16.1259C18 17.1615 17.1568 18.0009 16.1172 18.0009H3.88281C2.84325 18.0009 2.00002 17.1615 2 16.1259V6.92569C2.00007 5.89014 2.84327 5.05069 3.88281 5.05069H3.94043C3.94656 5.04385 3.95256 5.03685 3.95898 5.03018L6.36621 2.53604ZM3.88281 6.53995C3.66912 6.53995 3.49519 6.71283 3.49512 6.92569V16.1259C3.49514 16.3388 3.66909 16.5116 3.88281 16.5116H16.1172C16.3309 16.5116 16.5049 16.3388 16.5049 16.1259V13.7694H14.4941C13.2547 13.7694 12.25 12.7647 12.25 11.5253C12.2503 10.2861 13.2549 9.28122 14.4941 9.28116H16.5049V6.92569C16.5048 6.71283 16.3309 6.53995 16.1172 6.53995H3.88281ZM14.4941 10.7812C14.0833 10.7812 13.7503 11.1145 13.75 11.5253C13.75 11.9363 14.0832 12.2694 14.4941 12.2694H16.5049V10.7812H14.4941ZM7.77148 3.5419C7.67058 3.47229 7.53349 3.48595 7.44824 3.57413L6.02344 5.05069H9.95703L7.77148 3.5419Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.1a338a0d.svg";
export { ForwardRef as ReactComponent };